import { useSiteProvider } from '@/helpers/site';
import { getAuthor } from '@/api/author/AuthorApi';
import isNullOrEmpty from './isNullOrEmpty';

async function getCoverImage(content, cropType) {
  const { selectedSiteId } = useSiteProvider();

  if (content.type === 'column') {
    const authorId = content.author;

    if (!authorId) {
      throw new Error('getCoverImage: Column content must have an author');
    }
    const author = await getAuthor(authorId, selectedSiteId.value);

    if (isNullOrEmpty(author || author.profilePhoto)) {
      throw new Error('getCoverImage: Could not find author');
    }

    return author.profilePhoto.crops.find(crop => crop.type === cropType);
  }

  const selectedCoverImage = content.coverImage?.find(coverImage => coverImage.isSelected);

  if (isNullOrEmpty(selectedCoverImage || selectedCoverImage.crops)) {
    throw new Error('getCoverImage: Could not find any selected cover image');
  }

  return selectedCoverImage.crops.find(crop => crop.type === cropType);
}

export default getCoverImage;
